var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.583l-1.625 1.625-3.333-3.333 1.625-1.625a.848.848 0 01.625-.25c.25 0 .458.083.625.25l2.083 2.083c.167.167.25.375.25.625s-.083.459-.25.625zM1 13.667l9.834-9.835 3.334 3.334L4.333 17H1v-3.333z"
  })));
}
export default SvgEdit;